import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../PermissionsConstants";
import OfficeHierarchyTable from "../OfficeHierarchy/views/OfficeHierarchyTable";

const OfficeHierarchy = () => {
  const viewPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      <OfficeHierarchyTable />
    </>
  );
};

export default OfficeHierarchy;
